__turbopack_context__.v({
  "icon": "ListingCardTag-module__j_MYBG__icon",
  "tag": "ListingCardTag-module__j_MYBG__tag",
});
